"use client";

import React, { useMemo } from "react";
import CountryPhonePrompt from "./CountryPhonePrompt";
import { useLanguage } from "@/contexts/LanguageContext";
import { getStrings } from "@/i18n/dictionaries";

/**
 * Sub-country configs for Francophone MoMo phone prompt.
 * Maps sub-country code → display name + dial prefix.
 */
const FRANCOPHONE_COUNTRY_CONFIG = {
  BF: { name: "Burkina Faso", prefix: "+226" },
  CI: { name: "Côte d'Ivoire", prefix: "+225" },
  SN: { name: "Senegal", prefix: "+221" },
  CM: { name: "Cameroon", prefix: "+237" },
};

/**
 * Component to display when user tries XOF/XAF MoMo with a phone that doesn't
 * match the selected sub-country prefix.
 *
 * Wraps CountryPhonePrompt with dynamic configuration based on subCountryCode.
 * Mirrors the exact same UX as UgandaPhonePrompt / GhanaPhonePrompt / etc.
 */
export default function FrancophonePhonePrompt({
  onClose,
  onSwitchToStripe,
  detectedPhone,
  authPhone,
  profilePhone,
  profileCountry,
  selectedPaymentCountry,
  subCountryCode, // "BF" | "CI" | "SN" | "CM"
}) {
  const { locale } = useLanguage();
  const t = useMemo(() => getStrings(locale, "payment"), [locale]);
  const countryInfo = FRANCOPHONE_COUNTRY_CONFIG[subCountryCode] || {
    name: subCountryCode,
    prefix: "",
  };

  const config = {
    title: t.francophone_phone_title.replace("{country}", countryInfo.name),
    requiredPrefix: countryInfo.prefix,
    requiredCountryName: countryInfo.name,
  };

  return (
    <CountryPhonePrompt
      onClose={onClose}
      onSwitchToStripe={onSwitchToStripe}
      onSwitchToBankTransfer={null}
      detectedPhone={detectedPhone}
      authPhone={authPhone}
      profilePhone={profilePhone}
      profileCountry={profileCountry}
      selectedPaymentCountry={selectedPaymentCountry}
      config={config}
    />
  );
}
